import { Modal } from "antd";
import { useLeadImport } from "./hooks/useLeadImport";
import { Upload, Button } from "antd";
import { Upload as UploadIcon, Paperclip } from "lucide-react";

const ImportLeads = ({ open, handleCancel }) => {
  const {
    selectedFile,
    setSelectedFile,
    error,
    setError,
    loading,
    onImportLeads,
    onCreateLeads,
  } = useLeadImport(() => {
    handleCancel();
    setError();
    setSelectedFile();
  });
  const onCancel = () => {
    handleCancel();
    setError();
    setSelectedFile();
  };

  return (
    <Modal
      title="Import Leads"
      open={open}
      width="500px"
      onOk={onCreateLeads}
      closable={true}
      confirmLoading={loading}
      onCancel={onCancel}
    >
      <div className="py-2 d-flex align-items-start">
        <label className="pr-3 pt-1 white-space-nowrap">
          Choose file to import{" "}
        </label>
        <div>
          <Upload
            onChange={onImportLeads}
            showUploadList={false}
            accept=".csv, .xls, .xlsx"
            maxCount={1}
          >
            <Button
              className="d-flex align-items-center"
              icon={<UploadIcon size={16} />}
            >
              Click to Upload
            </Button>
          </Upload>
          {!!selectedFile && (
            <div className="pt-2 d-flex align-items-center">
              <Paperclip size={16} />{" "}
              <span className="pl-1 tw-text-[#1677ff]">
                {selectedFile?.name}
              </span>
            </div>
          )}
        </div>
      </div>
      <b>Note:</b>
      <p>
        To import leads, please ensure your file meets the following
        requirements:
      </p>
      <ul>
        <li>
          File format: <b>.csv</b> or <b>.xlsx</b>
        </li>
        <li>
          Mandatory headers:{" "}
          <b>First Name, Last Name, Email, Company Name, Mobile</b>
        </li>
        <li>
          Include headers:{" "}
          <b>
            First Name, Last Name, Designation, Email, Phone, Address, Website,
            Company Name, Industry, Lead Source, Mobile, Lead Description, Rate,
            Category, Status, Opportunity Amount
          </b>
        </li>
        <li>All mandatory fields must have valid data.</li>
      </ul>

      {error && error.length > 0 && (
        <ul className="py-4">
          {error.slice(0, 5).map((err, idx) => (
            <li key={idx} className="errorTxt">
              {err}
            </li>
          ))}
        </ul>
      )}
    </Modal>
  );
};

export default ImportLeads;
